<script setup lang="ts">
withDefaults(defineProps<{ rows?: number; cols?: number }>(), { rows: 5, cols: 4 })
</script>

<template>
  <div class="divide-y divide-line" aria-hidden="true">
    <div v-for="r in rows" :key="r" class="flex items-center gap-4 px-4 py-3">
      <div
        v-for="c in cols"
        :key="c"
        class="h-3 animate-pulse rounded-sm bg-raised"
        :style="{ width: c === 1 ? '28%' : `${12 + ((r + c) % 3) * 6}%` }"
      />
    </div>
  </div>
</template>
